<template>
  <div class="slc_w slc_wnw mb-x custom-radio">
    <label
        v-for="option in travelOptions"
        :key="option.value"
        class="slc"
        :class="{ slc_ac: localValue.includes(option.value) }"
    >
      <input
          type="checkbox"
          :value="option.value"
          name="travel_reason"
          v-model="localValue"
          :checked="localValue.includes(option.value)"
          @change="$emit('update:modelValue', this.localValue)"
          class="hidden"
      />
      <img :src="option.icon" loading="lazy" alt="" class="slc_i" />
      <div>{{ option.label }}</div>
    </label>
  </div>
</template>

<script>
import Options from "@/config/options";
export default {
  name: 'TravelReasonRadio',
  props: {
    modelValue: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      localValue: [],
      travelOptions: Options.travel_reason
    }
  },
}
</script>

<style scoped>
</style>
